/**
 * @namepace randomizer
 */
import getRandomInt from '../task/getRandomInt';

const lowerCaseChars = 'abcdefghijklmnopqrstuvwxyz';
const mixedCaseChars = lowerCaseChars + lowerCaseChars.toUpperCase();
const numericChars = '0123456789';
const hexadecimalChars = `${numericChars}abcdef`;
const lowerCaseAndNumericChars = lowerCaseChars + numericChars;
const mixedCaseAndNumericChars = mixedCaseChars + numericChars;

const createRandomStringFromPool = function(length, pool)
{
    const maxKeyInPool = pool.length - 1;
    const chars = [];

    for (let i = 0; i < length; i++)
    {
        chars[i] = pool.charAt(getRandomInt(0, maxKeyInPool));
    }

    return chars.join('');
};

const randomizer = /** @lends randomizer */
{
    /**
     * @param {number} [min=0]
     * @param {number} [max=1000000]
     * @return {number}
     */
    createInteger(min = 0, max = 1000000)
    {
        return getRandomInt(min, max);
    },

    /**
     * @param {number} [length=10]
     * @param {boolean} [mixedChars=false]
     * @return {string}
     */
    createAlphabeticString(length = 10, mixedChars = false)
    {
        return createRandomStringFromPool(
            length,
            mixedChars ? mixedCaseChars : lowerCaseChars
        );
    },

    /**
     * @param {number} [length=10]
     * @param {boolean} [mixedChars=false]
     * @return {string}
     */
    createAlphaNumericString(length = 10, mixedChars = false)
    {
        return createRandomStringFromPool(
            length,
            mixedChars ? mixedCaseAndNumericChars : lowerCaseAndNumericChars
        );
    },

    /**
     * @param {number} [length=10]
     * @return {string}
     */
    createNumericString(length = 10)
    {
        return createRandomStringFromPool(length, numericChars);
    },

    /**
     * @param {number} [length=10]
     * @return {string}
     */
    createHexadecimalString(length = 10)
    {
        return createRandomStringFromPool(length, hexadecimalChars);
    },

    /**
     * @return {string}
     */
    createUUID()
    {
        try
        {
            return globalThis.crypto.randomUUID();
        }
        catch (e)
        {
            const part1 = this.createHexadecimalString(8);
            const part2 = this.createHexadecimalString(4);
            const part3 = this.createHexadecimalString(4);
            const part4 = this.createHexadecimalString(4);
            const part5 = this.createHexadecimalString(12);
            return `${part1}-${part2}-${part3}-${part4}-${part5}`;
        }
    }
};

export default randomizer;
